module.exports = "/assets/8b4f8807218ab8da6a23239e46b6914c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/themes/api_logo_desktop.png
// module id = 591
// module chunks = 0